import { useToast } from '@chakra-ui/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { logger } from 'src/shared/Logger'
import { useIamStore } from '../../apis/store'
import { verifyUserByEmailApi } from '../../apis/verifyUserEmail'
import { UserStatusEnum } from '../../domain/user'
import { IAM_ERRORS } from '../../errors'

const useVerifyUserEmail = () => {
  const [isLoading, setLoading] = React.useState(false)
  const { send, setUserEmail } = useIamStore((store) => ({ send: store.sendEvent, setUserEmail: store.setUserEmail }))
  const toast = useToast()
  const [t] = useTranslation()
  const RawErrors: Record<string, string> = React.useMemo(
    () => ({
      [IAM_ERRORS.INTERNAL_ERROR]: t('login.validation.Something went wrong'),
      [IAM_ERRORS.USER_NOT_FOUND]: t('login.validation.not-registered'),
    }),
    [t],
  )
  const verifyEmail = React.useCallback(
    (email: string) => {
      setLoading(true)
      verifyUserByEmailApi({ email })
        .then((data) => {
          setLoading(false)
          setUserEmail(email)
          logger.setUser({ email })
          if (data.statusCode.includes(UserStatusEnum.RESET_REQUIRED)) send({ type: 'NEW_PASSWORD_REQUIRED' })
          else if (data.statusCode.includes(UserStatusEnum.EXTERNAL_PROVIDER)) {
            window.open(data.ssoRedirectUrl, '_self')
          }
          else if (data.statusCode.includes(UserStatusEnum.FORCE_CHANGE_PASSWORD))
            send({ type: 'NEW_PASSWORD_REQUIRED' })
          else if (data.statusCode.includes(UserStatusEnum.ELEGIBLE_AND_NOT_REGISTERED))
            send({ type: 'ELEGIBLE_AND_NOT_REGISTERED' })
          else if (data.statusCode.includes(UserStatusEnum.UNCONFIRMED)) send({ type: 'EMAIL_NOT_VERIFIED' })
          else if (data.statusCode.includes(UserStatusEnum.CONFIRMED)) send({ type: 'REGISTERED_USER' })
          else {
            throw new Error('unknown user state')
          }
        })
        .catch((error) => {
          setLoading(false)
          logger.error('email verification error', error)
          const message = RawErrors[error?.code] ?? RawErrors.INTERNAL_ERROR
          toast({
            title: message,
            isClosable: true,
            duration: 5000,
            status: 'error',
          })
          send({ type: 'INVALID_CREDENTIALS' })
        })
    },
    [RawErrors, send, setUserEmail, toast],
  )
  return { verifyEmail, isLoading }
}

export default useVerifyUserEmail
